import Component from '../core/Component'
import Scroll from '../services/Scroll'
import debounce from 'lodash/debounce'

const STATES = {
    READY: 'is-ready'
}

export default class Bg extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.bgGroups = []

    }

    prepare() {
        this.updateBgGroups()

        this.resize()
        this.element.classList.add(STATES.READY)

        Scroll.on('resize', this.handleResize)
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }

    updateBgGroups() {
        this.bgGroups = []
        const bgEdgeEls = document.querySelectorAll('[data-bg-start], [data-bg-end]')
        bgEdgeEls.forEach(bgEdgeEl => {
            const groupId = bgEdgeEl.dataset.bgStart || bgEdgeEl.dataset.bgEnd
            let group = this.bgGroups.find(group => group.id === groupId)
            if (!group) {
                group = {
                    id: groupId,
                    startEl: null,
                    endEl: null,
                    startOffset: 0,
                    endOffset: 0,
                    el: null
                }
                this.bgGroups.push(group)
            }
            if (bgEdgeEl.dataset.bgStart) {
                group.startEl = bgEdgeEl
                group.endOffset = bgEdgeEl.dataset.startOffset != undefined ? parseInt(bgEdgeEl.dataset.startOffset) : 0
            }
            if (bgEdgeEl.dataset.bgEnd) {
                group.endEl = bgEdgeEl
                group.endOffset = bgEdgeEl.dataset.bgEndOffset != undefined ? parseInt(bgEdgeEl.dataset.bgEndOffset) : 0
            }
        })

        this.element.innerHTML = ''
        this.bgGroups.forEach(bgGroup => {
            const el = document.createElement('div')
            el.className = `Bg-item Bg-item--${bgGroup.id}`
            bgGroup.el = el
            this.element.appendChild(el)
        })
    }

    resize() {
        const scroll = Scroll.getScroll()

        this.bgGroups.forEach(bgGroup => {
            let top = null
            let height = null

            const bgStartRect = bgGroup.startEl?.getBoundingClientRect()
            if (bgStartRect) {
                top = scroll.y + bgStartRect.top + bgGroup.startOffset
            } else {
                top = scroll.y + bgGroup.el.getBoundingClientRect().top
            }

            const bgEndRect = bgGroup.endEl?.getBoundingClientRect()
            if (bgEndRect) {
                height = (scroll.y + bgEndRect.top + bgEndRect.height + bgGroup.endOffset) - top
            } else {
                height = 0 //@todo do konce dokumentu?
            }

            if (top >= 0) {
                bgGroup.el.style.top = `${top}px`
            }
            if (height >= 0) {
                bgGroup.el.style.height = `${height}px`
            }
        })
    }
}
